const sessionDbSyncedKeys = new Set<string>();

function categoriesKey(): string {
  return 'categories';
}

function bundleKey(categoryName: string): string {
  return `bundle:${categoryName.trim()}`;
}

export function isAdminEvaluationPlanCategoriesSessionDbSynced(): boolean {
  return sessionDbSyncedKeys.has(categoriesKey());
}

export function markAdminEvaluationPlanCategoriesSessionDbSynced(): void {
  sessionDbSyncedKeys.add(categoriesKey());
}

export function isAdminEvaluationPlanBundleSessionDbSynced(categoryName: string): boolean {
  const name = categoryName.trim();
  if (!name) return false;
  return sessionDbSyncedKeys.has(bundleKey(name));
}

export function markAdminEvaluationPlanBundleSessionDbSynced(categoryName: string): void {
  const name = categoryName.trim();
  if (!name) return;
  sessionDbSyncedKeys.add(bundleKey(name));
}

export function invalidateAdminEvaluationPlanBundleSessionDbSynced(categoryName: string): void {
  const name = categoryName.trim();
  if (!name) return;
  sessionDbSyncedKeys.delete(bundleKey(name));
}

export function clearAdminEvaluationPlanSessionDbSync(): void {
  sessionDbSyncedKeys.clear();
}
